import styled from "@emotion/styled";
import { Container, Typography, Button, Box } from "@mui/material";

export const RootBox = styled(Box)({
  background: "#fff",

  borderRadius: "0.5rem",
});

export const LoginTitle = styled(Box)(({ theme }: any) => ({
  fontSize: "28px",
  fontWeight: 400,
  color: "#323232",
  lineHeight: "34px",
  marginBottom: "1.5rem",
  textAlign: "left",
  fontFamily: "Inter"
}));

export const SocialPill = styled(Button)(({ theme }: any) => ({
  background: "#FFF",
  border: `1px solid ${theme.palette.primary.main}`,
  borderRadius: "10rem",
  padding: "0.6rem 1rem",
  margin: "0.5rem",
}));
